import { MAX_APPLICANTS_TO_DISPLAY } from 'src/shared/constants';
export var getApplicantPosition = function (tabs, applicantId) {
    if (!applicantId) {
        return null;
    }
    var applicantIndex = tabs.findIndex(function (tab) { return tab.applicantId === applicantId; });
    if (applicantIndex === -1) {
        return null;
    }
    return applicantIndex + 1;
};
export var isApplicantPositionDisplayed = function (applicants, applicantId) {
    if (!applicantId || applicants.length <= 1) {
        return false;
    }
    var isTabCompressed = applicants.length > MAX_APPLICANTS_TO_DISPLAY;
    if (isTabCompressed) {
        return false;
    }
    return true;
};
